import { Component } from '@angular/core';
import { QuestionnaireComponent } from '../../questionnaire/questionnaire.component';
import { ApiService } from '../../_services/api.service';
import { ConfigService } from '../../_services/config.service';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'true-brief',  
  templateUrl: './brief.component.html',
  styleUrls: ['./brief.component.scss'],
  standalone: false
})
export class BriefComponent extends QuestionnaireComponent {
  constructor(api: ApiService, public readonly config: ConfigService, dialog: MatDialog) {
      super(api, config, dialog);
  }

  getTemplateId(): string {    
    return 'BRIEF';
  }
}
